<template>
  <ZigzagServiceLayout
    mainTitle="Diverse Care Now Educação"
    mainDescription="Programas de treinamento abrangentes para iniciar sua carreira na área da saúde."
    :sections="sections"
    :hideBookButton="true"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EducationContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'PROGRAMA DE FLEBOTOMIA',
          title: 'Diploma de Técnico em Flebotomia',
          subtitle: '165 Horas de Treinamento Abrangente',
          paragraphs: [
            "A Diverse Care Now Educação oferece um programa abrangente de Diploma de Técnico em Flebotomia de 165 horas, projetado para fornecer aos estudantes o conhecimento, habilidades práticas e treinamento prático necessários para a flebotomia.",
            "O programa combina instrução em sala de aula com treinamento prático supervisionado, incluindo técnicas de coleta de sangue, punção venosa, punção capilar, manuseio de amostras, controle de infecções, procedimentos de segurança, identificação do paciente e padrões profissionais."
          ],
          list: [
            "Técnicas de coleta de sangue e punção venosa",
            "Punção capilar e manuseio de amostras",
            "Controle de infecções e procedimentos de segurança",
            "Identificação do paciente e padrões profissionais"
          ],
          image: '/images/services/education-classroom.png'
        },
        {
          label: 'CERTIFICAÇÃO',
          title: 'Preparação para Certificação AMCA',
          subtitle: 'Seu caminho para uma carreira gratificante na área da saúde.',
          paragraphs: [
            "Após a conclusão bem-sucedida do programa de 165 horas, os estudantes recebem um Diploma de Técnico em Flebotomia e estão preparados para realizar o exame de certificação AMCA.",
            "Nosso programa fornece a base que você precisa para entrar no mercado de trabalho da saúde com confiança e competência."
          ],
          list: [
            "Programa: Diploma de Técnico em Flebotomia",
            "Duração: 165 Horas",
            "Instituição: Diverse Care Now Educação",
            "Treinamento: Sala de Aula e Habilidades Clínicas Práticas",
            "Preparação para Certificação: Exame de Certificação de Flebotomia AMCA"
          ],
          image: '/images/services/education-certification.png'
        }
      ]
    };
  }
};
</script>
